// import React, { useState, useEffect, useContext } from 'react';
// import { useParams, useNavigate, Link } from 'react-router-dom';
// import { ArrowLeft, Calendar, AlertTriangle, User, Edit, Trash2, Clock, CheckCircle, X } from 'lucide-react';
// import AuthContext from '../../../../context/AuthContext';
// import riskService from '../../../../services/riskService';
// import { useToast } from '../../../../context/ToastContext';

// // Simple Confirmation Dialog Component
// const ConfirmDialog = ({ isOpen, onClose, onConfirm, title, message, confirmText = "Confirmer", cancelText = "Annuler", confirmColor = "red" }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
//       <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" onClick={(e) => e.stopPropagation()}>
//         <div className="p-6">
//           <div className="flex items-start justify-between mb-4">
//             <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
//             <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
//               <X className="h-5 w-5" />
//             </button>
//           </div>
//           <p className="text-gray-600 mb-6">{message}</p>
//           <div className="flex justify-end space-x-3">
//             <button
//               onClick={onClose}
//               className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
//             >
//               {cancelText}
//             </button>
//             <button
//               onClick={() => {
//                 onConfirm();
//                 onClose();
//               }}
//               className={`px-4 py-2 ${
//                 confirmColor === 'red' 
//                   ? 'bg-red-600 hover:bg-red-700' 
//                   : 'bg-green-600 hover:bg-green-700'
//               } text-white rounded-lg transition-colors`}
//             >
//               {confirmText}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default function RiskDetails() {
//   const { riskId } = useParams();
//   const navigate = useNavigate();
//   const { user, hasRole, authTokens } = useContext(AuthContext);
//   const { showError, showSuccess } = useToast();

//   const [risk, setRisk] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
  
//   // Confirmation dialog state
//   const [confirmDialog, setConfirmDialog] = useState({
//     isOpen: false,
//     title: '',
//     message: '',
//     onConfirm: () => {},
//     confirmText: 'Confirmer',
//     confirmColor: 'red'
//   });

//   useEffect(() => {
//     if (riskId) {
//       fetchRiskDetails();
//     }
//   }, [riskId]);

//   const fetchRiskDetails = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       const result = await riskService.getRiskDetails(riskId, authTokens.access);
      
//       if (result.success) {
//         setRisk(result.data);
//         console.log(result.data);
//       } else {
//         setError(result.error);
//         showError(result.error || 'Erreur lors du chargement des détails du risque');
//       }
//     } catch (error) {
//       console.error('Error fetching risk details:', error);
//       setError('Erreur de connexion');
//       showError('Erreur de connexion');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const hasEditPermissions = () => {
//     return hasRole("RiskManager") || hasRole("RiskIdentifier");
//   };

//   const canEditRisk = (risk) => {
//     return hasEditPermissions() && risk.status.toLowerCase() !== "approved";
//   };


//   const canDeleteRisk = () => {
//     return hasRole("Admin");
//   };

//   const canValidateRisk = () => {
//     return hasRole("RiskManager") && risk?.status?.toLowerCase() === "pending";
//   };

//   const handleEditRisk = () => {
//     navigate(`/dashboard/risks/edit/${risk.id}`, { state: { risk } });
//   };

//   const handleDeleteRisk = () => {
//     setConfirmDialog({
//       isOpen: true,
//       title: 'Supprimer le risque',
//       message: 'Êtes-vous sûr de vouloir supprimer ce risque ? Cette action est irréversible.',
//       confirmText: 'Supprimer',
//       confirmColor: 'red',
//       onConfirm: async () => {
//         try {
//           const result = await riskService.deleteRisk(risk.id, authTokens.access);
          
//           if (result.success) {
//             showSuccess('Risque supprimé avec succès');
//             navigate('/dashboard/risks');
//           } else {
//             showError(result.error || 'Erreur lors de la suppression');
//           }
//         } catch (error) {
//           console.error('Error deleting risk:', error);
//           showError('Erreur de connexion');
//         }
//       }
//     });
//   };

//   const handleValidateRisk = (status) => {
//     const statusText = status === 'approved' ? 'approuver' : 'rejeter';
//     const statusTextCapital = status === 'approved' ? 'Approuver' : 'Rejeter';
    
//     setConfirmDialog({
//       isOpen: true,
//       title: `${statusTextCapital} le risque`,
//       message: `Êtes-vous sûr de vouloir ${statusText} ce risque ?`,
//       confirmText: statusTextCapital,
//       confirmColor: status === 'approved' ? 'green' : 'red',
//       onConfirm: async () => {
//         try {
//           const result = await riskService.validateRisk(risk.id, status, authTokens.access);
          
//           if (result.success) {
//             showSuccess(result.data.message || `Risque ${status === 'approved' ? 'approuvé' : 'rejeté'} avec succès`);
//             fetchRiskDetails();
//           } else {
//             showError(result.error || 'Erreur lors de la validation');
//           }
//         } catch (error) {
//           console.error('Error validating risk:', error);
//           showError('Erreur de connexion');
//         }
//       }
//     });
//   };

//   const closeConfirmDialog = () => {
//     setConfirmDialog({ ...confirmDialog, isOpen: false });
//   };

//   const getProbabiliteBadge = (probabilite) => {
//     const baseClasses = "px-3 py-1 rounded-full text-sm font-medium";
//     switch (probabilite?.toLowerCase()) {
//       case 'critique':
//         return `${baseClasses} bg-red-100 text-red-800`;
//       case 'majeur':
//         return `${baseClasses} bg-orange-100 text-orange-800`;
//       case 'normal':
//         return `${baseClasses} bg-yellow-100 text-yellow-800`;
//       case 'mineur':
//         return `${baseClasses} bg-blue-100 text-blue-800`;
//       default:
//         return `${baseClasses} bg-gray-100 text-gray-800`;
//     }
//   };

//   const getStatusBadge = (status) => {
//     const baseClasses = "px-3 py-1 rounded-full text-sm font-medium";
//     switch (status?.toLowerCase()) {
//       case 'validé':
//       case 'approved':
//         return `${baseClasses} bg-green-100 text-green-800`;
//       case 'rejeté':
//       case 'rejected':
//         return `${baseClasses} bg-red-100 text-red-800`;
//       case 'en-cours':
//         return `${baseClasses} bg-yellow-100 text-yellow-800`;
//       case 'pending':
//         return `${baseClasses} bg-gray-100 text-gray-800`;
//       default:
//         return `${baseClasses} bg-gray-100 text-gray-800`;
//     }
//   };

//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString('fr-FR', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric'
//     });
//   };

//   const formatDateTime = (dateString) => {
//     return new Date(dateString).toLocaleString('fr-FR', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   const isActionOverdue = (dueDate) => {
//     if (!dueDate) return false;
//     return new Date(dueDate) < new Date();
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600"></div>
//       </div>
//     );
//   }



//   if (error) {
//     return (
//       <div className="space-y-6">
//         <div className="flex items-center space-x-3">
//           <Link 
//             to={-1}
//             className="p-2 text-gray-500 hover:text-gray-700 rounded-lg"
//           >
//             <ArrowLeft className="h-5 w-5" />
//           </Link>
//           <h2 className="text-xl font-semibold text-gray-900">Détails du Risque</h2>
//         </div>
        
//         <div className="bg-red-50 border border-red-200 rounded-lg p-6">
//           <p className="text-red-800 mb-4">{error}</p>
//           <div className="flex space-x-3">
//             <button 
//               onClick={fetchRiskDetails}
//               className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
//             >
//               Réessayer
//             </button>
//             <Link
//               to="/dashboard/risks"
//               className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
//             >
//               Retour à la liste
//             </Link>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!risk) {
//     return (
//       <div className="space-y-6">
//         <div className="flex items-center space-x-3">
//           <Link 
//             to={-1}
//             className="p-2 text-gray-500 hover:text-gray-700 rounded-lg"
//           >
//             <ArrowLeft className="h-5 w-5" />
//           </Link>
//           <h2 className="text-xl font-semibold text-gray-900">Risque non trouvé</h2>
//         </div>
        
//         <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
//           <p className="text-gray-600 mb-4">Le risque demandé n'existe pas ou vous n'avez pas les permissions pour le voir.</p>
//           <Link
//             to={-1}
//             className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700"
//           >
//             Retour à la liste des risques
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   const totalActions = risk?.actions?.length || 0;
//   const completedActions = risk?.actions?.filter(action => action.is_completed)?.length || 0;

//   const canUpdateProbability = (risk) => {
//     return hasEditPermissions() && completedActions > 0;
//   };
//   return (

//     <>
//       <ConfirmDialog
//         isOpen={confirmDialog.isOpen}
//         onClose={closeConfirmDialog}
//         onConfirm={confirmDialog.onConfirm}
//         title={confirmDialog.title}
//         message={confirmDialog.message}
//         confirmText={confirmDialog.confirmText}
//         confirmColor={confirmDialog.confirmColor}
//       />

//       <div className="space-y-6">
//         {/* Header */}
//         <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
//           <div className="flex items-center space-x-3">
//             <Link 
//               to={-1}
//               className="p-2 text-gray-500 hover:text-gray-700 rounded-lg"
//             >
//               <ArrowLeft className="h-5 w-5" />
//             </Link>
//             <div>
//               <h2 className="text-xl font-semibold text-gray-900">Détails du Risque</h2>
//               <p className="text-sm text-gray-500">ID: {risk.id}</p>
//             </div>
//           </div>

//           <div className="flex space-x-2">
//             {canEditRisk(risk) && (
//               <button
//                 onClick={handleEditRisk}
//                 className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
//               >
//                 <Edit className="h-4 w-4 mr-2" />
//                 Modifier
//               </button>
//             )}
//             {canUpdateProbability(risk) && (
//               <button
//                 onClick={handleEditRisk}
//                 className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
//               >
//                 <Edit className="h-4 w-4 mr-2" />
//                 Update Probability
//               </button>
//             )}
            
//             {/* {canDeleteRisk() && (
//               <button
//                 onClick={handleDeleteRisk}
//                 className="flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
//               >
//                 <Trash2 className="h-4 w-4 mr-2" />
//                 Supprimer
//               </button>
//             )} */}

//             {canValidateRisk() && (
//               <div className="flex space-x-2">
//                 <button
//                   onClick={() => handleValidateRisk('approved')}
//                   className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
//                 >
//                   Approuver
//                 </button>
//                 <button
//                   onClick={() => handleValidateRisk('rejected')}
//                   className="flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
//                 >
//                   Rejeter
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Risk Information */}
//         <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6">

//           <div className='flex items-center md:justify-between'>
//               <h3 className="text-lg font-semibold text-gray-900 mb-2">{risk.risk_name}</h3>

//                 {totalActions > 0 && (
//                   <span className="text-sm text-gray-600">
//                     Tâches du risques terminées   <span className='text-green-800 text-md'>{completedActions}</span>/<span className='text-red-400'>{totalActions}</span>
//                   </span>
//                 )}
//           </div>
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//             {/* Left Column */}
//             <div className="space-y-4">
//               <div>

//                 <div className="flex items-center space-x-2 mb-4">
//                   <span className={getProbabiliteBadge(risk.probability)}>
//                     {risk.probability}
//                   </span>
//                   <span className={getStatusBadge(risk.status)}>
//                     {risk.status}
//                   </span>
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
//                 <p className="text-gray-900 bg-gray-50 p-3 rounded-md">{risk.description}</p>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   <AlertTriangle className="w-4 h-4 inline mr-1" />
//                   Conséquence
//                 </label>
//                 <p className="text-gray-900 bg-gray-50 p-3 rounded-md">{risk.consequence}</p>
//               </div>
//             </div>

//             {/* Right Column */}
//             <div className="space-y-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   <Calendar className="w-4 h-4 inline mr-1" />
//                   Date du risque
//                 </label>
//                 <p className="text-gray-900">{formatDate(risk.risk_date)}</p>
//               </div>

//               {risk.created_by_details && (
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     <User className="w-4 h-4 inline mr-1" />
//                     Créé par
//                   </label>
//                   <p className="text-gray-900">
//                     {risk.created_by_details.first_name} {risk.created_by_details.last_name}
//                     <span className="text-gray-500 text-sm block">{risk.created_by_details.email}</span>
//                   </p>
//                 </div>
//               )}

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   <Clock className="w-4 h-4 inline mr-1" />
//                   Créé le
//                 </label>
//                 <p className="text-gray-900">{formatDateTime(risk.created_at)}</p>
//               </div>

//               {risk.updated_at !== risk.created_at && (
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Dernière modification
//                   </label>
//                   <p className="text-gray-900">{formatDateTime(risk.updated_at)}</p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Actions Section */}
//         <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6">
//           {/* <h3 className="text-lg font-semibold text-gray-900 mb-4">
//             Actions ({risk.actions?.length || 0})
//           </h3> */}

//           <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center justify-between">
//             <span>Actions ({totalActions})</span>
           
//           </h3>


//           {risk.actions && risk.actions.length > 0 ? (
//             <div className="space-y-4">
//               {risk.actions.map((action, index) => (
//                 <div key={action.id || index} className="border border-gray-200 rounded-lg p-4 bg-gray-50">
//                   <div className="flex items-start justify-between mb-3">
//                     <h4 className="font-medium text-gray-900">Action {index + 1}</h4>
//                     {action.dueDate && (
//                       <div className={`flex items-center text-sm ${
//                         isActionOverdue(action.dueDate) 
//                           ? 'text-red-600' 
//                           : 'text-gray-500'
//                       }`}>
//                         <Calendar className="w-4 h-4 mr-1" />
//                         {formatDate(action.dueDate)}
//                         {isActionOverdue(action.dueDate) && (
//                           <span className="ml-2 px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">
//                             En retard
//                           </span>
//                         )}
//                       </div>
//                     )}
//                   </div>

//                   <div className="mb-3">
//                     <p className="text-gray-900">{action.action}</p>
                    
//                   </div>

//                   <div className='flex items-center justify-between'>

//                     {action.assignedUserObject && (
//                       <div className="flex items-center text-sm text-gray-600">
//                         <User className="w-4 h-4 mr-2" />
//                         <div>
//                           <span>
//                             Assigné à: {action.assignedUserObject.first_name} {action.assignedUserObject.last_name}
//                             <span className="text-gray-400 ml-1">({action.assignedUserObject.email})</span>
//                           </span>
//                           <p>
//                             Sur le rôle {action.assignedUserObject.roles && action.assignedUserObject.roles.length > 0 && (
//                               <span className="ml-2 text-xs text-blue-500">
//                               - {action.userRoleAssignedObject?.role_name}
//                             </span>
//                           )}
//                           </p>
//                           {action.assignedUserObject.roles && action.assignedUserObject.roles.length > 0 && (
//                             !action.userRoleAssignedObject?.is_active && (
//                               <p> NB: Ce rôle n'est plus disponible pour cet utilisateur</p>
//                             )
//                           )}
//                         </div>
//                       </div>
//                     )}

//                     <p>Task <span className={`${action.is_completed? 'bg-green-100 text-green-800':'bg-yellow-100 text-yellow-800'} p-2 rounded text-sm`}>{action.is_completed? "Completed":"Not Completed"}</span></p>
//                   </div>

                  
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="text-center py-8 text-gray-500">
//               <CheckCircle className="w-12 h-12 mx-auto mb-3 text-gray-300" />
//               <p className="text-lg font-medium">Aucune action définie</p>
//               <p className="text-sm">Ce risque n'a pas d'actions préventives ou correctives associées.</p>
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// }









import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { ArrowLeft, Calendar, AlertTriangle, User, Edit, Trash2, Clock, CheckCircle, X, ChevronDown } from 'lucide-react';
import AuthContext from '../../../../context/AuthContext';
import riskService from '../../../../services/riskService';
import { useToast } from '../../../../context/ToastContext';

// Simple Confirmation Dialog Component
const ConfirmDialog = ({ isOpen, onClose, onConfirm, title, message, confirmText = "Confirmer", cancelText = "Annuler", confirmColor = "red" }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" onClick={(e) => e.stopPropagation()}>
        <div className="p-6">
          <div className="flex items-start justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <X className="h-5 w-5" />
            </button>
          </div>
          <p className="text-gray-600 mb-6">{message}</p>
          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
            >
              {cancelText}
            </button>
            <button
              onClick={() => {
                onConfirm();
                onClose();
              }}
              className={`px-4 py-2 ${
                confirmColor === 'red' 
                  ? 'bg-red-600 hover:bg-red-700' 
                  : 'bg-green-600 hover:bg-green-700'
              } text-white rounded-lg transition-colors`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function RiskDetails() {
  const { riskId } = useParams();
  const navigate = useNavigate();
  const { user, hasRole, authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();

  const [risk, setRisk] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showProbabilityDropdown, setShowProbabilityDropdown] = useState(false);
  
  // Confirmation dialog state
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: () => {},
    confirmText: 'Confirmer',
    confirmColor: 'red'
  });

  const probabiliteOptions = [
    { value: 'mineur', label: 'Mineur', color: 'bg-blue-100 text-blue-800' },
    { value: 'normal', label: 'Normal', color: 'bg-yellow-100 text-yellow-800' },
    { value: 'majeur', label: 'Majeur', color: 'bg-orange-100 text-orange-800' },
    { value: 'critique', label: 'Critique', color: 'bg-red-100 text-red-800' }
  ];

  useEffect(() => {
    if (riskId) {
      fetchRiskDetails();
    }
  }, [riskId]);

  const fetchRiskDetails = async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await riskService.getRiskDetails(riskId, authTokens.access);
      
      if (result.success) {
        setRisk(result.data);
        console.log(result.data);
      } else {
        setError(result.error);
        showError(result.error || 'Erreur lors du chargement des détails du risque');
      }
    } catch (error) {
      console.error('Error fetching risk details:', error);
      setError('Erreur de connexion');
      showError('Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  const hasEditPermissions = () => {
    return hasRole("RiskManager") || hasRole("RiskIdentifier");
  };

  const canEditRisk = (risk) => {
    return hasEditPermissions() && risk.status.toLowerCase() !== "approved";
  };

  const canDeleteRisk = () => {
    return hasRole("Admin");
  };

  const canValidateRisk = () => {
    return hasRole("RiskManager") && risk?.status?.toLowerCase() === "pending";
  };

  const handleEditRisk = () => {
    navigate(`/dashboard/risks/edit/${risk.id}`, { state: { risk } });
  };

  const handleDeleteRisk = () => {
    setConfirmDialog({
      isOpen: true,
      title: 'Supprimer le risque',
      message: 'Êtes-vous sûr de vouloir supprimer ce risque ? Cette action est irréversible.',
      confirmText: 'Supprimer',
      confirmColor: 'red',
      onConfirm: async () => {
        try {
          const result = await riskService.deleteRisk(risk.id, authTokens.access);
          
          if (result.success) {
            showSuccess('Risque supprimé avec succès');
            navigate('/dashboard/risks');
          } else {
            showError(result.error || 'Erreur lors de la suppression');
          }
        } catch (error) {
          console.error('Error deleting risk:', error);
          showError('Erreur de connexion');
        }
      }
    });
  };

  const handleValidateRisk = (status) => {
    const statusText = status === 'approved' ? 'approuver' : 'rejeter';
    const statusTextCapital = status === 'approved' ? 'Approuver' : 'Rejeter';
    
    setConfirmDialog({
      isOpen: true,
      title: `${statusTextCapital} le risque`,
      message: `Êtes-vous sûr de vouloir ${statusText} ce risque ?`,
      confirmText: statusTextCapital,
      confirmColor: status === 'approved' ? 'green' : 'red',
      onConfirm: async () => {
        try {
          const result = await riskService.validateRisk(risk.id, status, authTokens.access);
          
          if (result.success) {
            showSuccess(result.data.message || `Risque ${status === 'approved' ? 'approuvé' : 'rejeté'} avec succès`);
            fetchRiskDetails();
          } else {
            showError(result.error || 'Erreur lors de la validation');
          }
        } catch (error) {
          console.error('Error validating risk:', error);
          showError('Erreur de connexion');
        }
      }
    });
  };

  const handleUpdateProbability = async (newProbability) => {
    try {
      const result = await riskService.updateRiskProbability(risk.id, newProbability, authTokens.access);
      
      if (result.success) {
        showSuccess('Probabilité mise à jour avec succès');
        setShowProbabilityDropdown(false);
        fetchRiskDetails();
      } else {
        showError(result.error || 'Erreur lors de la mise à jour de la probabilité');
      }
    } catch (error) {
      console.error('Error updating probability:', error);
      showError('Erreur de connexion');
    }
  };

  const closeConfirmDialog = () => {
    setConfirmDialog({ ...confirmDialog, isOpen: false });
  };

  const getProbabiliteBadge = (probabilite) => {
    const baseClasses = "px-3 py-1 rounded-full text-sm font-medium";
    switch (probabilite?.toLowerCase()) {
      case 'critique':
        return `${baseClasses} bg-red-100 text-red-800`;
      case 'majeur':
        return `${baseClasses} bg-orange-100 text-orange-800`;
      case 'normal':
        return `${baseClasses} bg-yellow-100 text-yellow-800`;
      case 'mineur':
        return `${baseClasses} bg-blue-100 text-blue-800`;
      default:
        return `${baseClasses} bg-gray-100 text-gray-800`;
    }
  };

  const getStatusBadge = (status) => {
    const baseClasses = "px-3 py-1 rounded-full text-sm font-medium";
    switch (status?.toLowerCase()) {
      case 'validé':
      case 'approved':
        return `${baseClasses} bg-green-100 text-green-800`;
      case 'rejeté':
      case 'rejected':
        return `${baseClasses} bg-red-100 text-red-800`;
      case 'en-cours':
        return `${baseClasses} bg-yellow-100 text-yellow-800`;
      case 'pending':
        return `${baseClasses} bg-gray-100 text-gray-800`;
      default:
        return `${baseClasses} bg-gray-100 text-gray-800`;
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString('fr-FR', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const isActionOverdue = (dueDate) => {
    if (!dueDate) return false;
    return new Date(dueDate) < new Date();
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-6">
        <div className="flex items-center space-x-3">
          <Link 
            to={-1}
            className="p-2 text-gray-500 hover:text-gray-700 rounded-lg"
          >
            <ArrowLeft className="h-5 w-5" />
          </Link>
          <h2 className="text-xl font-semibold text-gray-900">Détails du Risque</h2>
        </div>
        
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          <p className="text-red-800 mb-4">{error}</p>
          <div className="flex space-x-3">
            <button 
              onClick={fetchRiskDetails}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
            >
              Réessayer
            </button>
            <Link
              to="/dashboard/risks"
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
            >
              Retour à la liste
            </Link>
          </div>
        </div>
      </div>
    );
  }

  if (!risk) {
    return (
      <div className="space-y-6">
        <div className="flex items-center space-x-3">
          <Link 
            to={-1}
            className="p-2 text-gray-500 hover:text-gray-700 rounded-lg"
          >
            <ArrowLeft className="h-5 w-5" />
          </Link>
          <h2 className="text-xl font-semibold text-gray-900">Risque non trouvé</h2>
        </div>
        
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
          <p className="text-gray-600 mb-4">Le risque demandé n'existe pas ou vous n'avez pas les permissions pour le voir.</p>
          <Link
            to={-1}
            className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700"
          >
            Retour à la liste des risques
          </Link>
        </div>
      </div>
    );
  }

  const totalActions = risk?.actions?.length || 0;
  const completedActions = risk?.actions?.filter(action => action.is_completed)?.length || 0;

  const canUpdateProbability = (risk) => {
    return hasEditPermissions() && completedActions > 0 && risk.status.toLowerCase() == "approved";
  };

  return (
    <>
      <ConfirmDialog
        isOpen={confirmDialog.isOpen}
        onClose={closeConfirmDialog}
        onConfirm={confirmDialog.onConfirm}
        title={confirmDialog.title}
        message={confirmDialog.message}
        confirmText={confirmDialog.confirmText}
        confirmColor={confirmDialog.confirmColor}
      />

      <div className="space-y-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <div className="flex items-center space-x-3">
            <Link 
              to={-1}
              className="p-2 text-gray-500 hover:text-gray-700 rounded-lg"
            >
              <ArrowLeft className="h-5 w-5" />
            </Link>
            <div>
              <h2 className="text-xl font-semibold text-gray-900">Détails du Risque</h2>
              <p className="text-sm text-gray-500">ID: {risk.id}</p>
            </div>
          </div>

          <div className="flex space-x-2">
            {canEditRisk(risk) && (
              <button
                onClick={handleEditRisk}
                className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
              >
                <Edit className="h-4 w-4 mr-2" />
                Modifier
              </button>
            )}
            
            {canUpdateProbability(risk) && (
              <div className="relative">
                {/* <button
                  onClick={() => setShowProbabilityDropdown(!showProbabilityDropdown)}
                  className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                >
                  <Edit className="h-4 w-4 mr-2" />
                  Update Probability
                  <ChevronDown className="h-4 w-4 ml-2" />
                </button> */}

                {showProbabilityDropdown && (
                  <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
                    {probabiliteOptions.map((option) => (
                      <button
                        key={option.value}
                        onClick={() => handleUpdateProbability(option.value)}
                        className="w-full text-left px-4 py-2 hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg"
                      >
                        <span className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${option.color}`}>
                          {option.label}
                        </span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            )}

            {canValidateRisk() && (
              <div className="flex space-x-2">
                <button
                  onClick={() => handleValidateRisk('approved')}
                  className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
                >
                  Approuver
                </button>
                <button
                  onClick={() => handleValidateRisk('rejected')}
                  className="flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                >
                  Rejeter
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Risk Information */}
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6">
          <div className='flex items-center md:justify-between'>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">{risk.risk_name}</h3>

            {totalActions > 0 && (
              <span className="text-sm text-gray-600">
                Tâches du risques terminées   <span className='text-green-800 text-md'>{completedActions}</span>/<span className='text-red-400'>{totalActions}</span>
              </span>
            )}
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Left Column */}
            <div className="space-y-4">
              <div>
                <div className="flex items-center space-x-2 mb-4">
                  <span className={getProbabiliteBadge(risk.probability)}>
                    {risk.probability}
                  </span>
                  <span className={getStatusBadge(risk.status)}>
                    {risk.status}
                  </span>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                <p className="text-gray-900 bg-gray-50 p-3 rounded-md">{risk.description}</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  <AlertTriangle className="w-4 h-4 inline mr-1" />
                  Conséquence
                </label>
                <p className="text-gray-900 bg-gray-50 p-3 rounded-md">{risk.consequence}</p>
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  <Calendar className="w-4 h-4 inline mr-1" />
                  Date du risque
                </label>
                <p className="text-gray-900">{formatDate(risk.risk_date)}</p>
              </div>

              {risk.created_by_details && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    <User className="w-4 h-4 inline mr-1" />
                    Créé par
                  </label>
                  <p className="text-gray-900">
                    {risk.created_by_details.first_name} {risk.created_by_details.last_name}
                    <span className="text-gray-500 text-sm block">{risk.created_by_details.email}</span>
                  </p>
                </div>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  <Clock className="w-4 h-4 inline mr-1" />
                  Créé le
                </label>
                <p className="text-gray-900">{formatDateTime(risk.created_at)}</p>
              </div>

              {risk.updated_at !== risk.created_at && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Dernière modification
                  </label>
                  <p className="text-gray-900">{formatDateTime(risk.updated_at)}</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Actions Section */}
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center justify-between">
            <span>Actions ({totalActions})</span>
          </h3>

          {risk.actions && risk.actions.length > 0 ? (
            <div className="space-y-4">
              {risk.actions.map((action, index) => (
                <div key={action.id || index} className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                  <div className="flex items-start justify-between mb-3">
                    <h4 className="font-medium text-gray-900">Action {index + 1}</h4>
                    {action.dueDate && (
                      <div className={`flex items-center text-sm ${
                        isActionOverdue(action.dueDate) 
                          ? 'text-red-600' 
                          : 'text-gray-500'
                      }`}>
                        <Calendar className="w-4 h-4 mr-1" />
                        {formatDate(action.dueDate)}
                        {isActionOverdue(action.dueDate) && (
                          <span className="ml-2 px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">
                            En retard
                          </span>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    <p className="text-gray-900">{action.action}</p>
                  </div>

                  <div className='flex items-center justify-between'>
                    {action.assignedUserObject && (
                      <div className="flex items-center text-sm text-gray-600">
                        <User className="w-4 h-4 mr-2" />
                        <div>
                          <span>
                            Assigné à: {action.assignedUserObject.first_name} {action.assignedUserObject.last_name}
                            <span className="text-gray-400 ml-1">({action.assignedUserObject.email})</span>
                          </span>
                          <p>
                            Poste/rôle actuel {action.assignedUserObject.role_function  && (
                              <span className="ml-2 text-xs text-blue-500">
                              - {action.assignedUserObject?.role_function}
                            </span>
                          )}
                          </p>
                          {/* {action.assignedUserObject.roles && action.assignedUserObject.roles.length > 0 && (
                            !action.userRoleAssignedObject?.is_active && (
                              <p> NB: Ce rôle n'est plus disponible pour cet utilisateur</p>
                            )
                          )} */}
                        </div>
                      </div>
                    )}

                    {/* <p>Task <span className={`${action.is_completed? 'bg-green-100 text-green-800':'bg-yellow-100 text-yellow-800'} p-2 rounded text-sm`}>{action.is_completed? "Completed":"Not Completed"}</span></p> */}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-8 text-gray-500">
              <CheckCircle className="w-12 h-12 mx-auto mb-3 text-gray-300" />
              <p className="text-lg font-medium">Aucune action définie</p>
              <p className="text-sm">Ce risque n'a pas d'actions préventives ou correctives associées.</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}